'use client'

import { useEffect, useRef, useState } from 'react'

interface Props {
    children: React.ReactNode
    className?: string
    delay?: number
    threshold?: number
}

const ScrollReveal = ({ children, className = '', delay = 0, threshold = 0.1 }: Props) => {
    const ref = useRef<HTMLDivElement>(null)
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const el = ref.current
        if (!el) return
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    if (delay) {
                        setTimeout(() => setVisible(true), delay)
                    } else {
                        setVisible(true)
                    }
                    observer.unobserve(el)
                }
            },
            { threshold }
        )
        observer.observe(el)
        return () => observer.disconnect()
    }, [delay, threshold])

    return (
        <div
            ref={ref}
            className={`transition-all duration-700 ease-out ${
                visible
                    ? 'opacity-100 translate-y-0'
                    : 'opacity-0 translate-y-6'
            } ${className}`}
        >
            {children}
        </div>
    )
}

export default ScrollReveal
